import api from "./api";

export const fetchAllDriverPartners = async (
    page = 1,
    size = 20,
    filterField = null,
    filterValue = null
) => {
    try {
        const params = {
            page,
            size,
        };

        if (filterField && filterValue) {
            params.filter_field = filterField;
            params.filter_value = filterValue;
        }

        const response = await api.get(
            "/driver-partner-management/driver-partners",
            {
                params,
            }
        );

        if (
            response.status === 200 &&
            response.data.success
        ) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch Driver Partners",
        };
    }
};

export const updateDriverPartnerStatus = async (
    driverPartnerId,
    status,
    statusReason = ""
) => {
    try {
        const payload = {
            status,
            status_reason: statusReason,
        };

        const response = await api.put(
            `/driver-partner-management/driver-partners/${driverPartnerId}/status`,
            payload
        );

        if (
            response.status === 200 &&
            response.data.success
        ) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };
    } catch (error) {
        console.error(
            "Error updating Driver Partner:",
            error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to update Driver Partner status",
        };
    }
};

